exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reply .owner-name[data-v-3c26f8cc] {\n  font-size: 1.1em;\n  font-weight: bold;\n}\n.reply-container[data-v-3c26f8cc] {\n  background-color: #eee;\n  padding: 20px;\n}\n.reply-container textarea[data-v-3c26f8cc] {\n  background-color: #fff;\n}", ""]);

// exports
